import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import LeftMenu from "../Components/LeftMenu";

const Lodbaking = () => {
  return (
    <Container>
      <Row>
        <Col lg="4">
          <LeftMenu />
        </Col>
        <Col lg="8">
          <h1 className="toph1 font-mont">ABOUT</h1>
          <p>Video tutorial on how to bake LOD map in Blender:</p>
          <iframe
            className="myvideo"
            src="https://www.youtube.com/embed/i8b5n7I-t4E"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
          <br />
          <br />
        </Col>
      </Row>
    </Container>
  );
};

export default Lodbaking;
